import client from './client';
import { SellerWaitlistEntry, WaitlistEntry } from '../types';

export const joinWaitlist = async (payload: {
  productId: string;
  productOptionId?: string;
  orderSheetId: string;
  storeId: string;
  customerName: string;
  customerPhone: string;
  quantity: number;
}): Promise<WaitlistEntry> => {
  const response = await client.post('waitlists', payload);
  return response.data;
};

export const getMyWaitlists = async (params?: {
  storeId?: string;
  orderSheetId?: string;
}): Promise<WaitlistEntry[]> => {
  const response = await client.get('waitlists/my', { params });
  return response.data;
};

export const cancelWaitlist = async (
  waitlistEntryId: string,
): Promise<WaitlistEntry> => {
  const response = await client.delete(`waitlists/${waitlistEntryId}`);
  return response.data;
};

export const getSellerProductWaitlist = async (params: {
  productId: string;
  productOptionId?: string;
  orderSheetIds?: string[];
}): Promise<SellerWaitlistEntry[]> => {
  const response = await client.get('waitlists/admin/entries', {
    params: {
      productId: params.productId,
      productOptionId: params.productOptionId,
      orderSheetIds: params.orderSheetIds?.join(','),
    },
  });
  return response.data;
};
